import AddMembers from "../components/AddMembers";
import {
  CHATGROUP_DATA,
  GROUPMEMBER_DELETE_DATA,
  GROUPMESSAGE_GET_DATA,
  GROUPMESSAGE_ADD_DATA,
  CHATMETRICS_DATA, 
  USERMETRICS_DATA,
  WVMETRICS_DATA,
  GROUPMEMBER_ADD_DATA,
  CHAT_IMPORT_DATA,
  CHAT_GROUPAUDIT_DATA,
  CHAT_USERAUDIT_DATA,

} from "./Constants";
const initialState = {
  loading: false,
  error: null,
  chatgroup: [],  
  user : [],
  chatmetrics: [],
  member: {},
  message:[],
  newMessage: [],
  addmembers: {},
  wvmetrics: [],
  chatupload: {},
  groupaudit: {},
  useraudit:{},
};
const Reducer = (state = initialState, action) => {
  switch (action.type) {
    //load all
    case CHATGROUP_DATA.CHATGROUP_DATA_LOAD:
      return {
        ...state,
        loading: true,
        chatgroup: [],
        error: null,
      };
    case CHATGROUP_DATA.CHATGROUP_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        chatgroup: action.chatgroup,
      };
    case CHATGROUP_DATA.CHATGROUP_DATA_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

      //load user metrics
    case USERMETRICS_DATA.USERMETRICS_DATA_LOAD:
      return {
        ...state,
        loading: true,
        user: [],
        error: null,
      };
    case USERMETRICS_DATA.USERMETRICS_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        user: action.user,
      };
    case USERMETRICS_DATA.USERMETRICS_DATA_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
      //load chat metrics
    case CHATMETRICS_DATA.CHATMETRICS_DATA_LOAD:
      return {
        ...state,
        loading: true,
        chatmetrics: [],
        error: null,
      };
    case CHATMETRICS_DATA.CHATMETRICS_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        chatmetrics: action.chatmetrics,
      };
    case CHATMETRICS_DATA.CHATMETRICS_DATA_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

      //load wv metrics
    case WVMETRICS_DATA.WVMETRICS_DATA_LOAD:    
      return {
        ...state,
        loading: true,
        wvmetrics: [],
        error: null,
      };
    case WVMETRICS_DATA.WVMETRICS_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        wvmetrics: action.wvmetrics,
      };
    case WVMETRICS_DATA.WVMETRICS_DATA_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
      };  
      
      //load message
    case GROUPMESSAGE_GET_DATA.GROUPMESSAGE_GET_DATA_LOAD:
      return {
        ...state,
        loading: true,
        message: [],
        error: null,
      };

    case GROUPMESSAGE_GET_DATA.GROUPMESSAGE_GET_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        message: action.message,
      };

    case GROUPMESSAGE_GET_DATA.GROUPMESSAGE_GET_DATA_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
        };
     // reset message
     case GROUPMESSAGE_GET_DATA.GROUPMESSAGE_CLEAR_DATA:
      return {
        ...state,
        message: [], //  Clears the message array
        error: null,
        };
   
    // Delete group members
    case GROUPMEMBER_DELETE_DATA.GROUPMEMBER_DELETE_DATA_LOAD:
      return {
        ...state,
        loading: true,
        member: {},
        error: null,
      };
    case GROUPMEMBER_DELETE_DATA.GROUPMEMBER_DELETE_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        member: action.member,
        error: null,
      };
    case GROUPMEMBER_DELETE_DATA.GROUPMEMBER_DELETE_DATA_FAIL:
      return {
        ...state,
        loading: false,
        member: {},
        error: action.error,
      }; 
      // Add Message
    case GROUPMESSAGE_ADD_DATA.GROUPMESSAGE_ADD_DATA_LOAD:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GROUPMESSAGE_ADD_DATA.GROUPMESSAGE_ADD_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        message: action.message,
      };
    case GROUPMESSAGE_ADD_DATA.GROUPMESSAGE_ADD_DATA_FAIL:
      return {
        ...state,
        loading: false,
        newMessage: [],
        error: action.error,
      };
      // Add Member
    case GROUPMEMBER_ADD_DATA.GROUPMEMBER_ADD_DATA_LOAD:
      return {
        ...state,
        loading: true,
        addmembers: {},
        error: null,
      };
    case GROUPMEMBER_ADD_DATA.GROUPMEMBER_ADD_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        addmembers: action.addmembers,
      };
    case GROUPMEMBER_ADD_DATA.GROUPMEMBER_ADD_DATA_FAIL:
      return {
        ...state,
        loading: false,
        addmembers: {},
        error: action.error,
      };

      //CHAT Import 
      case CHAT_IMPORT_DATA.CHAT_IMPORT_DATA_LOAD:
        return {
            ...state,
            loading:true,
            error:null,
            chatupload:{},
            
        }
    case CHAT_IMPORT_DATA.CHAT_IMPORT_DATA_SUCCESS:
        return {
            ...state,
            loading:false,
            chatupload:action.chatupload,
            error:null,
            
        }
    case CHAT_IMPORT_DATA.CHAT_IMPORT_DATA_FAIL:
        return {
            ...state,
            loading:false,
            error:action.error,
            chatupload:{},
            
        }

        //CHAT Group Audit Data
      case CHAT_GROUPAUDIT_DATA.CHAT_GROUPAUDIT_DATA_LOAD:
        return {
            ...state,
            loading:true,
            error:null,
            groupaudit:{},
            
        }
    case CHAT_GROUPAUDIT_DATA.CHAT_GROUPAUDIT_DATA_SUCCESS:
        return {
            ...state,
            loading:false,
            groupaudit:action.groupaudit,
            error:null,
            
        }
    case CHAT_GROUPAUDIT_DATA.CHAT_GROUPAUDIT_DATA_FAIL:
        return {
            ...state,
            loading:false,
            error:action.error,
            groupaudit:{},
            
        }
        //CHAT User Audit Data
      case CHAT_USERAUDIT_DATA.CHAT_USERAUDIT_DATA_LOAD:
        return {
            ...state,
            loading:true,
            error:null,
            useraudit:{},
            
        }
    case CHAT_USERAUDIT_DATA.CHAT_USERAUDIT_DATA_SUCCESS:
        return {
            ...state,
            loading:false,
            useraudit:action.useraudit,
            error:null,
            
        }
    case CHAT_USERAUDIT_DATA.CHAT_USERAUDIT_DATA_FAIL:
        return {
            ...state,
            loading:false,
            error:action.error,
            groupaudit:{},
            
        }
    
    default:
      return {
        ...state,
      };
  }
};
export default Reducer;
